var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-item",
    { class: { hovered: _vm.hovered } },
    [
      _c(
        "q-item-side",
        [
          _c(
            "q-item-tile",
            { attrs: { avatar: "" } },
            [
              _c("user-avatar", {
                attrs: { user: _vm.member, height: "38px", width: "38px" }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("q-item-main", [
        _c("div", { staticClass: "row items-center gutter-x-md q-pl-md" }, [
          _c(
            "div",
            { staticClass: "col-md-4 col-6" },
            [
              _c("span", [
                _vm._v("\n          " + _vm._s(_vm.name) + "\n        ")
              ]),
              _vm.member.id === _vm.user.id
                ? _c(
                    "q-chip",
                    {
                      staticClass: "on-right",
                      attrs: { color: "positive", small: "" }
                    },
                    [_vm._v(_vm._s(_vm.$t("you")))]
                  )
                : _vm._e()
            ],
            1
          ),
          _c("div", { staticClass: "col-4 gt-sm" }, [
            _c("span", { staticClass: "text-faded" }, [
              _vm._v(_vm._s(_vm.member.email))
            ])
          ]),
          _vm.user.isAdminOf(_vm.team)
            ? _c(
                "div",
                {
                  staticClass:
                    "col-md-4 col-6 text-right team-list-entry__controls"
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("q-select", {
                          attrs: {
                            type: "radio",
                            disable: _vm.memberIsOwner,
                            options: _vm.possibleRoles,
                            value: _vm.member.role_id
                          },
                          on: {
                            change: _vm.handleUpdateRole,
                            focus: function($event) {
                              _vm.hovered = true
                            },
                            blur: function($event) {
                              _vm.hovered = false
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("q-btn", {
                          attrs: {
                            icon: "close",
                            flat: "",
                            dense: "",
                            disabled: _vm.memberIsOwner
                          },
                          on: { click: _vm.handleRemoveMember }
                        })
                      ],
                      1
                    )
                  ])
                ]
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }